import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { Component } from 'react'

export default class Statista extends Component {
    render() {
        return (
            <div className='main1'>
                <div className='first'>
                    <FontAwesomeIcon icon={['fas', 'quote-left']} style={{ fontSize: `20px`, color: 'black' }} />
                    <h3>Source: Statista</h3>
                </div>
                <div>
                    <h4>Did you know 86% of adults who read non-fiction earn over $75,000 a year—and 53% make more than $100K? A small investment now could mean a big return in your future.</h4>
                </div>
                <style>
                    {`
                        .main1 {
                        padding: 12px 20px;
                            color: white;
                            box-shadow: 0 8px 16px 0 rgba(0,11,40,.05);
                            border-radius: 12px;
                        }
                            .first {
                                display: flex;
                                justify-content: space-between;
                            }
                    `}
                </style>
            </div>
        )
    }
}
